/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1078
 */

var r = require(/* 194 */"../../1648/194")
var o = require(/* 231 */"../../1282/231")
var /* [auto-meaningful-name] */r$document = r.document
var a = o(r$document) && o(r$document.createElement)
module.exports = function (e) {
  return a ? r$document.createElement(e) : {}
}
